<template>
  <div class="container" :class="{english:$i18n.locale=='en'}">
    <headLine index="3" ref="dialog" showbar="true" @on-locale-change="onLocaleChange">
      {{$t('product.name')}}
    </headLine>

    <div class="banner banner1">
        <img :src="imglist[0]" alt="">    
        <h1 class="banner_title" v-html="$t('product.banner_text')">
          
        </h1>
        <h1 class="banner_title banner_title1" v-html="$t('product.banner_text2')">
          
        </h1>
        <div class="center button_banner" style="position:absolute;top:4.02rem;width:100%">
          <router-link to="/software"><a  class="button_default"  v-html="$t('product.banner_botton')"></a></router-link>
        </div>
    </div>

    <div class="content center">
      <div class="content_item content_item2">
        <h3 class="content_item_title" v-html="$t('product.introduction_title')">
        </h3>

        <img v-lazy="imglist[2]" style="width: 100%;height: 3.38rem">
        <div class="content_item_text">{{$t('product.introduction_text13')}}
</div>
        <img v-lazy="imglist[3]" style="width: 100%;height: 3.38rem">
        <div class="content_item_text">
          {{$t('product.introduction_text11')}}
        </div>

        <img v-lazy="imglist[4]" style="width: 100%;height: 3.38rem">
        <div class="content_item_text" style="margin-bottom: 0.7rem">
          {{$t('product.introduction_text12')}}
        </div>





      </div>
      <div class="content center" style="background-color:rgba(238,245,254,1) ">
        <div class="content_item">
          <h3 class="content_item_title" v-html="$t('product.introduction_title2')" style="margin-bottom: 0.25rem">
          </h3>
          <div class="content_item_text">
              {{$t('product.introduction_text2')}}
          </div>
          <div class="content_item_text">
              {{$t('product.introduction_text21')}}
          </div>
          <div class="content_item_text">
              {{$t('product.introduction_text22')}}
          </div>
          <img v-lazy="imglist[5]" style="width:7.25rem;height: 6.56rem;margin:0 auto;margin-top: -0.2rem;padding-bottom: 0.4rem">
        </div>
       
      </div>

      <div class="content center" >
        <div class="content_item">
          <h3 class="content_item_title" v-html="$t('product.introduction_title4')" style="margin-bottom: 0.25rem">
          </h3>
          <ul class="platformList clearfix">
            <li><span class="mult_platform"></span></li>
            <li><span class="mult_platform1"></span></li>
            <li><span class="mult_platform2"></span></li>
            <li><span class="mult_platform3"></span></li>
            <li><span class="mult_platform4"></span></li>
            <li><span class="mult_platform5"></span></li>
          </ul>
          <h5 class="content_item_text2">{{$t('product.introduction_title5')}}</h5>
          <a class="button_default button_default2" style="margin-bottom: 0.7rem" @click="showDialog()">{{$t('product.text45')}}</a>
        </div>
       
      </div>
    </div>
    <footerLine></footerLine>  
  </div>

</template>

<script>
import headLine from "./header"
import footerLine from "./footer"
import myVideo from 'vue-video';
import Vue from 'vue'
import i18n from '../common/i18n'


export default {
  name: 'index',
  i18n:i18n,
  data () {
    return {
      imglist:[
        "/static/images/Banner-BG@2x.png",
        "/static/images/img1.png",
        "/static/images/product/Lording@2x.png",
        "/static/images/product/change@2x.png",
        "/static/images/product/IMAX@2x.png",
        "/static/images/product/app mock-up@2x.png"
        


      ],
      showTab:1,
      show_play_btn:true,
      video: {
          sources: [{
              src: 'https://img.vrviu.com/static/media/BG_loop.mp4',
              type: 'video/mp4'
          }],
          options: {
              autoplay: false,
              volume: 0.6,
              poster: 'https://img.vrviu.com/static/images/img7.png'
          }
      },
    }
  },
  watch:{

  },

  created () {
    var language = navigator.language; //取得浏览器版本语言
    var initLanguage = "";
    if(localStorage.locale){
      this.$i18n.locale = localStorage.locale;
    }else{
      if (language.indexOf('zh') > -1){
        initLanguage="ch"; //中文页面
      }else if (language.indexOf('en') > -1){
        initLanguage="en"; //英文页面
      }
      this.$i18n.locale = initLanguage;
    }
    if(this.$i18n.locale=="ch"){
      this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg"
    }else{
      this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png"
    }
  },
  methods:{
    play_video(){
      setTimeout(()=>{
        this.$refs.video.fullScreen();
      })
      this.$refs.video.$video
.addEventListener('ended', (e) => {
          this.show_play_btn = true;
      },false)
        this.$refs.video.play();
        this.show_play_btn = false;
    },
    showDialog(){
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if(this.$i18n.locale=="en"){
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";

      }else{
        this.$refs.dialog.content_type2 = "申请使用威尔云";

      }
    },
    onLocaleChange:function(val){
      this.$i18n.locale=val;
      if(this.$i18n.locale=="ch"){
        this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg"
      }else{
        this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png"
      }
    }
  },
  components:{
    headLine,
    myVideo,
    footerLine
  }
}
</script>

<style scoped>
.platformList{
  width: 5.9rem;
  margin: 0 auto;
}
.platformList li{
  float: left;
  margin-right: 0.37rem;

}
.content_item_text2{
  font-size: 0.22rem;
  color:rgba(100,100,100,1);
  margin-top: 0.35rem;
}

.platformList .mult_platform{
  display: inline-block;
  width: 1.71rem;
  height: 1.71rem;
  background: url(../assets/images/product/icon_Cardboard@2x.png);
  background-size: contain;
}
.platformList .mult_platform1{
  display: inline-block;
  width: 1.71rem;
  height: 1.71rem;
  background: url(../assets/images/product/icon_Pico@2x.png);
  background-size: contain;
}
.platformList .mult_platform2{
  display: inline-block;
  width: 1.71rem;
  height: 1.71rem;
  background: url(../assets/images/product/icon_MiVR@2x.png);
  background-size: contain;
}
.platformList .mult_platform3{
  display: inline-block;
  width: 1.71rem;
  height: 1.71rem;
  background: url(../assets/images/product/icon_Vive@2x.png);
  background-size: contain;
}
.platformList .mult_platform4{
  display: inline-block;
  width: 1.71rem;
  height: 1.71rem;
  background: url(../assets/images/product/icon_Oculus@2x.png);
  background-size: contain;

}
.platformList .mult_platform5{
  display: inline-block;
  width: 1.71rem;
  height: 1.71rem;
  background: url(../assets/images/product/icon_xiao@2x.png);
  background-size: contain;

}

.platformList  li:nth-child(3n){
    margin-right: 0!important
} 
.content_item2  .content_item_text{
  margin-top: 0.3rem
}

.why_content{
  margin-left: 1.13rem;
  margin-top: 0.4rem
}
.why_icon{
  display: inline-block;
  width:1.4rem;
  height: 1.4rem;
  background: url(../assets/images/product/why_icon.png) no-repeat;
  background-size: cover; 
}
.why_icon1{
  display: inline-block;
  width:1.4rem;
  height: 1.4rem;
  background: url(../assets/images/product/why_icon1.png) no-repeat;
  background-size: cover; 
}
.why_icon2{
  display: inline-block;
  width:1.4rem;
  height: 1.4rem;
  background: url(../assets/images/product/why_icon2.png) no-repeat;
  background-size: cover; 
}
.why_icon3{
  display: inline-block;
  width:1.4rem;
  height: 1.4rem;
  background: url(../assets/images/product/why_icon3.png) no-repeat;
  background-size: cover; 
}

.why_title{
  font-size: 0.32rem;
  color: #282828;
  margin-top: 0.13rem

}
.why_text{
  font-size: 0.22rem;
  color:#646464;
  text-align: left;
  line-height: 1.5em;
  margin-top: 0.3rem
}
.support_model{
  font-size: 0.3rem;
  color:#282828;
  margin-top: 0.4rem;
}
.friendsList img{
  display: inline-block!important;
}
.support_model span{
  display: inline-block;
  width: 0.8rem;
  padding-bottom: 0.22rem;
  margin-bottom: 0.3rem;
  cursor: pointer;
}
.support_model span.active_tab{
    color:#0986ff;
    border-bottom:2px solid #0986ff;
}
.playBtn{
  display: inline-block;
  width: 0.8rem;
  height: 0.8rem;
  background:url(../assets/images/playBtn.png) no-repeat;
  background-size: cover;
  position: absolute;
  top:3rem;
  left:50%;
  transform: translate(-50%,0);
  z-index: 2000;
}

@media screen and (orientation: landscape) {
  .banner_title1{
    top: 48%!important
  }
  .button_banner{
    top:63%!important
  }
}
.english .button_banner h2{
  /*margin-top:3.2rem!important;*/
}
.banner{
  height: 7rem
}
.english .banner_title{
  font-size: 0.6rem;
}

.banner_title{
  top:2.56rem;
  font-size: 0.54rem;
}
.banner_title1{
  top: 3.28rem
}
.guaid_arrow{
  display: inline-block;
  height: 0.19rem;
  width: 0.34rem;
  background:url(../assets/images/banner/banner_icon_down.png) no-repeat;
  background-size: cover;
  margin-top: 0.4rem;
}
.english .notice{
  font-size: 0.22rem;
}
  
.notice{
  height: 0.9rem;
  line-height: 0.9rem;
  color:#282828;
  font-size: 0.24rem;
  border-bottom: 1px solid #E5E5E5;
}

.pic_item img{
  margin-top: 0;
  width: 100%;
  height: 100%;

}
.pic_item .middle{
  width: 100%;
}
.pic_content1 .fl,.pic_content1 .fr{
  width: 50%
}
.pic_content .pic_item{
  margin-bottom: 0.06rem;
  position: relative;
  height: 2.5rem
}

.pictures{
  margin-left: 0.32rem;
  margin-right: 0.32rem;
  margin-bottom: 0.63rem;
}
.pic_content1 .pic_item{
  margin-right: 0.03rem;
}
.pic_content1 .pic_item2{
  margin-left: 0.03rem;
  margin-right: 0;
}
.__cov-video-container{
  border-radius: 0.04rem!important;

}
.content_bg{
  height: 7.54rem;
  width: 7.5rem;
  background-size: cover;
  position: relative;
  background-color: rgb(244, 249, 255)
}
.content_footer{
  position: absolute;
  left:50%;
  transform: translate(-50%,0);
  width: 100%;
  bottom: 1.1rem;
}
.english .content_footer{
 /*bottom: 0.7rem;*/

}
.english .content_footer .button_default {
  margin-top: 0.2rem!important;
}

</style>



// WEBPACK FOOTER //
// product1.vue?386827b6